<template>
<div>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <header-table titlePage="RELATÓRIO DE COMPRAS" :data="tableData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="6" :totalPDF="total - 1" titleReport="Relatório de Compras">
                    <md-button class="md-button md-site md-just-icon md-round" :to="{ name: 'Dashboard' }">
                        <md-icon>dashboard</md-icon>
                        <md-tooltip md-direction="top">Dashboard</md-tooltip>
                    </md-button>
                </header-table>
                <md-card-content>
                    <div class="md-layout">

                        <div class="md-layout-item md-size-20 md-xsmall-size-100">
                            <md-field>
                                <label>FATURAS</label>
                                <md-select v-model="buscar.periodo">
                                    <md-option v-for="item in faturas" :key="item" :value="item">
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-size-15 md-xsmall-size-100 ml-auto">
                            <md-field>
                                <label for="pages">Listar</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                        {{ item}}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-size-40 md-xsmall-size-100">
                            <md-field md-clearable class="md-toolbar-section-end">
                                <md-input placeholder="Pesquise aqui..." v-model="search" @input="searchOnTable" />
                            </md-field>
                        </div>
                    </div>
                    <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                        <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                            <md-table-cell md-label="CÓDIGO" style="width: 10%">{{ item.id }}</md-table-cell>
                            <md-table-cell class="uppercase" md-label="FORNECEDOR" style="width: 50%">{{ item.fornecedor }}</md-table-cell>
                            <md-table-cell md-label="DATA" style="width: 10%">{{ item.data_pagamento }}</md-table-cell>
                            <md-table-cell md-label="VENCIMENTO" style="width: 10%">{{ item.data_vencimento }}</md-table-cell>
                            <md-table-cell v-if="item.id" md-label="PARCELA" style="width: 10%">{{ item.parcela }}</md-table-cell>
                            <md-table-cell v-if="!item.id" md-label="PARCELA" style="width: 10%"><strong>{{ item.parcela }}</strong></md-table-cell>
                            <md-table-cell v-if="item.id" md-label="VALOR" style="width: 10%">{{ item.valor }}</md-table-cell>
                            <md-table-cell v-if="!item.id" md-label="VALOR" style="width: 10%"><strong>{{ item.valor }}</strong></md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <footer-table :from="from" :to="to" :total="total">
                    <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
                </footer-table>
            </md-card>
        </div>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            faturas: [],
            cliente_id: this.$route.params.id,
            columnsPDF: [17, 70, 25, 25, 20, 23],
            headRowsPDF: ['CÓDIGO', 'FORNECEDOR', 'DATA', 'VENCIMENTO', 'PARCELA', 'VALOR'],
            bodyRowsPDF: ['id', 'fornecedor', 'data_pagamento', 'data_vencimento', 'parcela', 'valor'],
            fildsTXT: ['id', 'fornecedor', 'data_pagamento', 'data_vencimento', 'parcela', 'valor_txt'],
            columnsExcel: [

                {
                    label: "CÓDIGO",
                    field: "id"
                },
                {
                    label: "FORNECEDOR",
                    field: "fornecedor",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "DATA",
                    field: "data_pagamento"
                },
                {
                    label: "VENCIMENTO",
                    field: "data_vencimento"
                },
                
                {
                    label: "PARCELA",
                    field: "parcela"
                },
                {
                    label: "VALOR",
                    field: "valor_bd"
                },
            ],
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                periodo: ''
            }
        };
    },

    watch: {
        'buscar.periodo': function (value) {
            this.carregar()
        },
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.$http.get(this.$urlAPI + 'home/faturas/' + this.cliente_id)
                .then(response => {                   
                    if (response.data.status) {
                        this.faturas = response.data.dados;
                        this.buscar.periodo = response.data.dados[0];
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.fornecedor, item.data_pagamento, item.data_vencimento, item.valor_parcela]).includes(this.toLower(term)))
            }
            return items
        },

        carregar() {
            this.buscar.cliente_id = this.cliente_id;
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'pagamentos/cliente', this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        }
    },
};
</script>
